import React from 'react';

import * as S from '../utilities/styledComponents/Gearbox';

import './style/style.scss';

import iconMegaphone from '../../img/megaphone.svg';

import FormUser from '../FormUser';
import Card from '../Card';
import { ContentTitle } from '../utilities/styledComponents/ContentTitle';
import { CockpitFormGroupStyle } from '../utilities/styledComponents/CockpitFormGroupStyle';

const UserRegisiter = () => (
	<CockpitFormGroupStyle>
		<S.MainContent id="gearbox-content">
			<div className="App">
				<ContentTitle>Usuário</ContentTitle>
				<div className="container">
					<div className="row">
						<div className="col-12">
							<Card
								icon={iconMegaphone}
								classComponent="m-3"
								altIcon=""
								titleIcon="Dados do usuário"
								title="Dados do usuário"
								classButton=""
								textButton=""
								linkButton={null}
								eventButton={null}
								targetButton=""
							>
								<FormUser
									messageSuccess="Usuário criado com sucesso!"
									formValues=""
									apiUri="/users"
									apiMethod="post"
								/>
							</Card>
						</div>
					</div>
				</div>
			</div>
		</S.MainContent>
	</CockpitFormGroupStyle>
);

export default UserRegisiter;
